import React from 'react';
import pl, { Translations } from './translations/pl';
import de from './translations/de';

export type Language = 'pl' | 'de';

const translations: Record<Language, Translations> = { pl, de };

interface LanguageContextType {
    language: Language;
    setLanguage: (lang: Language) => void;
    t: Translations;
}

export const LanguageContext = React.createContext<LanguageContextType>({
    language: 'pl',
    setLanguage: () => {},
    t: pl,
});

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const getInitialLanguage = (): Language => {
        if (typeof window === 'undefined') return 'pl';
        const stored = localStorage.getItem('language') as Language | null;
        if (stored && stored in translations) return stored;
        const browser = navigator.language.slice(0, 2).toLowerCase();
        if (browser === 'de') return 'de';
        return 'pl';
    };

    const [language, setLanguageState] = React.useState<Language>(getInitialLanguage);

    const setLanguage = (lang: Language) => {
        setLanguageState(lang);
        if (typeof window !== 'undefined') {
            localStorage.setItem('language', lang);
        }
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t: translations[language] }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useTranslation = () => React.useContext(LanguageContext);
